import {LIST_STATE, LIST_ACTIVITY, LIST_INVENTORY, CLEAR_LIST} from '../../../Helper/actionsTypes';

const listReducer = (state=[], action) => {
  switch (action.type) {
    case LIST_STATE:{
      return action.error
        ? {...state, stateList: []}
        : {...state, stateList: action.payload};
    }
    case LIST_ACTIVITY:{
      return action.error
        ? {...state, activity: []}
        : {...state, activity: action.payload};
    }
    case LIST_INVENTORY:{
      return action.error
        ? {...state, inventory: []}
        : {...state, inventory: action.payload};
    }
    case CLEAR_LIST: return {};
    default: return state;
  }
};

export default listReducer;